// extracted by mini-css-extract-plugin
export default {"commission_info":"commission_info","bold":"bold","link":"link"};